<template>
    <div class="multistep-wizard-splashscreen">
        <div class="row">
            <div class="col-12 col-sm-6 -col-lg-4 col-xl-3"
                 v-for="(option, needle) in splashOptions"
                 :key="`option-${needle}`">
                <div class="splash-option" @click="selectOption(option)">
                    <i :class="`icon ${option.font_class}`"></i>
                    <div class="title">{{option.title}}</div>
                    <div class="description">{{option.description}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-apprentice-multistep-form-wizard-splashscreen",
    emits:['selected-splash-option'],
    props: {
        splashOptions: {
            type: Array,
            required: true,
        }
    },
    methods: {
        selectOption(option) {
            this.$emit('selected-splash-option', option)
        }
    }
}
</script>

<style scoped>

</style>
